const escapeRegExp = (value: string): string => value.replaceAll(new RegExp(String.raw`[.*+?^{}$()|[\]\\]`, 'g'), String.raw`\$&`)

export const buildInstallerUsernameRegex = (firstName: string, lastName: string): RegExp =>
  new RegExp(String.raw`^${escapeRegExp(firstName)}\.${escapeRegExp(lastName)}\d*$`, 'i')
